export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
export const SUCURSALES = ['APO', 'MEX', 'GDL', 'JRZ', 'SPG'];
export const COLORES = { APO: '#1d3d6b', MEX: '#0086ab', GDL: '#3cafd6', JRZ: '#00a86b', SPG: '#ff6b6b' };
export const DOMINIO_PERMITIDO = '@acerosleal.com';
export const SESION_URL = API_URL.replace(/proxy$/, 'sesion');
export const EVENTO_SESION_VENCIDA = 'sigrh:sesion-vencida';

export function fmtFecha(iso) {
  if (!iso) return '—';
  const s = String(iso).slice(0, 10);
  if (s.length < 10) return s;
  return s.slice(8, 10) + '/' + s.slice(5, 7) + '/' + s.slice(0, 4);
}

export function descargarBase64(base64, filename) {
  const bytes = atob(base64);
  const arr = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
  const blob = new Blob([arr], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
}

export const SUCURSAL_NOMBRES = {
  APO: 'Apodaca',
  MEX: 'Mexico',
  GDL: 'Guadalajara',
  JRZ: 'Juárez',
  SPG: 'San Pedro'
};

export const SUCURSAL_ESTADO = {
  APO: 'Nuevo León',
  SPG: 'Nuevo León',
  GDL: 'Jalisco',
  MEX: 'Estado de México',
  JRZ: 'Chihuahua'
};

export const MUNICIPIOS_POR_ESTADO = {
  'Nuevo León': ['Apodaca', 'Juárez', 'Ciénega de Flores', 'Pesquería', 'Gral. Zuazua', 'San Nicolás de los Garza', 'San Pedro Garza García', 'Monterrey', 'El Carmen', 'García', 'Guadalupe', 'Cadereyta'],
  'Jalisco': ['Tlajomulco de Zúñiga', 'San Pedro Tlaquepaque', 'El Salto', 'Tonalá', 'Ixtlahuacán de los Membrillos', 'Chapala', 'Jilotlán', 'Acatlán de Juárez'],
  'Estado de México': ['Chalco', 'Cocotitlán', 'Tlamanalco', 'Ixtapaluca', 'Amecameca'],
  'Chihuahua': ['Ciudad Juárez']
};

export const ESTADOS_MEXICO = [
  'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 'Chiapas', 'Chihuahua',
  'CDMX', 'Coahuila', 'Colima', 'Durango', 'Guanajuato', 'Guerrero', 'Hidalgo', 'Jalisco',
  'Estado de México', 'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León', 'Oaxaca', 'Puebla',
  'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora', 'Tabasco', 'Tamaulipas',
  'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
];

export const OPCIONES_SUCURSALES = Object.entries(SUCURSAL_NOMBRES).map(([value, label]) => ({ value, label }));

export function decodificarJWT(token) {
  const payloadBase64 = token.split('.')[1];
  const payloadJson = decodeURIComponent(
    atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'))
      .split('')
      .map(c => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
      .join('')
  );
  return JSON.parse(payloadJson);
}
